import React from "react";
import PropTypes from "prop-types";
import Form from "../../common/Form";
import Section from "../../common/Section";
import Fieldset from "../../common/Fieldset";
import LinkInput from "../../common/LinkInput";
import Row from "../../common/Row";

const SocialeMediaForm = (props) => {
    const {
        goToNext,
        goToPrev,
        model,
        onChange,
        errors,
        validationMessageType,
        facebookHasFocus
    } = props;

    return (
        <Section>
            <Form
                name="socialeMedia"
                headerVisible={false}
                isNotRequired
                rightButtonLabel="Ga verder"
                leftButtonLabel="Terug"
                onRightButtonClick={goToNext}
                onLeftButtonClick={goToPrev}
            >
                <Fieldset>
                    <Row><div style={{ color: "#082b42", fontSize: "1.4375rem", fontWeight: "500", lineHeight: "28px", margin: "30px 0.83333% 0 0.83333%" }}>Sociale media</div></Row>
                </Fieldset>
                <div style={{ width: "100%", height: "1px", backgroundColor: "#E6E6E6", marginTop: "30px" }}></div>
                <Fieldset>
                <LinkInput
                        name="facebookLink"
                        label="Facebook"
                        value={model.facebookLink}
                        onChange={onChange}
                        validationMessage={errors ? errors['facebookLink'] : ""}
                        validationMessageType={validationMessageType}
                        size={12}
                        optional
                        inputmask="https://www.facebook.com/"
                        faIconClassname="fa-facebook c-facebook"
                        hasFocus={facebookHasFocus}
                        hideRevert
                    />
                    <LinkInput
                        name="linkedInLink"
                        label="LinkedIn"
                        value={model.linkedInLink}
                        onChange={onChange}
                        validationMessage={errors ? errors['linkedInLink'] : ""}
                        validationMessageType={validationMessageType}
                        size={12}
                        optional
                        inputmask="https://www.linkedin.com/"
                        faIconClassname="fa-linkedin c-linkedin"
                        hideRevert
                    />
                    <LinkInput
                        name="instagramLink"
                        label="Instagram"
                        value={model.instagramLink}
                        onChange={onChange}
                        validationMessage={errors ? errors['instagramLink'] : ""}
                        validationMessageType={validationMessageType}
                        size={12}
                        optional
                        inputmask="https://www.instagram.com/"
                        faIconClassname="fa-instagram c-instagram"
                        hideRevert
                    />
                    <LinkInput
                        name="youtubeLink"
                        label="YouTube"
                        value={model.youtubeLink}
                        onChange={onChange}
                        validationMessage={errors ? errors['youtubeLink'] : ""}
                        validationMessageType={validationMessageType}
                        size={12}
                        optional
                        inputmask="https://www.youtube.com/"
                        faIconClassname="fa-youtube c-youtube"
                        hideRevert
                    />

                </Fieldset>
            </Form>
        </Section>

    );
};

SocialeMediaForm.propTypes = {
    goToNext: PropTypes.func,
    goToPrev: PropTypes.func,
    model: PropTypes.object,
    onChange: PropTypes.func,
    errors: PropTypes.object,
    validationMessageType: PropTypes.string,
    facebookHasFocus: PropTypes.bool
};

export default SocialeMediaForm;